import { ServiceCache } from '@mimir/common/client/serviceCache';
import { ofServiceDocument } from '@mimir/client-common/aws/api/basicPaths';
import { initializeI18n } from '@mimir/common/i18n/initializeI18n';
import { getApplicationContext } from './util/getApplicationContext';
import { initializeBrowserBehavior } from '@mimir/client-common/util/browserBehavior';
import axios from 'axios';
import * as ui from './ui';
import { invariant } from '@mimir/common/util/invariant';

function resolveApiRootSetting(env_: Record<string, string | undefined>) {
  return env_['VUE_APP_AWS_API_PREFIX'] ?? env_['MIMIR_HOME_URL'] ?? '';
}

function resolveRelativeUrl(relUrl: string) {
  const url = document.createElement('a');
  url.href = relUrl;
  return url.port !== window.location.port ? relUrl : window.location.origin;
}

invariant(typeof __USE_IMPORT_META__ !== 'undefined', 'Unexpected execution environment without verified import.meta');
/*
  Required by amazon-cognito-identity-js dependency used by
  persistentUserSession.ts
*/
(window as any).global = window;

const rootUrl = resolveRelativeUrl(resolveApiRootSetting(import.meta.env));
const serviceDocUrl = ofServiceDocument(rootUrl);
const serviceCache = new ServiceCache(serviceDocUrl, axios);
serviceCache.startPreload();
const applicationContext = getApplicationContext();

const initializeUi = async () => {
  try {
    await initializeI18n();
    initializeBrowserBehavior();
    ui.initialize(serviceCache, applicationContext);
  } catch (err) {
    const errMsg = `${err}`;
    if (errMsg === 'TypeError: Failed to fetch dynamically imported module: http://localhost:8080/src/ui.ts') {
      alert('Outdated vite dependencies!\n\nYou need to delete the folder clients/vuetify/node_modules/.vite, restart your dev server and reload the page.');
    }
  }
};

/*
  We get better error reports with call stacks if we do not catch the exception
  here.
*/
void initializeUi();
